import {use} from 'echarts/core';
import {CanvasRenderer} from 'echarts/renderers';
import {BarChart, BoxplotChart, LineChart, ScatterChart} from 'echarts/charts';
import {GridComponent, LegendComponent, MarkLineComponent, TooltipComponent} from 'echarts/components';

// tree-shaken ECharts: only what the dashboard charts use
use([CanvasRenderer, BarChart, BoxplotChart, LineChart, ScatterChart, GridComponent, LegendComponent, MarkLineComponent, TooltipComponent]);
